import type { FC, SVGProps } from 'react';

export const FileTextIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    fill="none"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="black"
      fillOpacity="0.25"
      d="M12.3531 3.50938L8.99063 0.146875C8.89688 0.053125 8.77031 0 8.6375 0H2C1.72344 0 1.5 0.223437 1.5 0.5V13.5C1.5 13.7766 1.72344 14 2 14H12C12.2766 14 12.5 13.7766 12.5 13.5V3.86406C12.5 3.73125 12.4469 3.60313 12.3531 3.50938ZM11.3469 4.09375H8.40625V1.15313L11.3469 4.09375ZM11.375 12.875H2.625V1.125H7.34375V4.5C7.34375 4.67405 7.41289 4.84097 7.53596 4.96404C7.65903 5.08711 7.82595 5.15625 8 5.15625H11.375V12.875ZM6.875 8.65625H4C3.93125 8.65625 3.875 8.7125 3.875 8.78125V9.53125C3.875 9.6 3.93125 9.65625 4 9.65625H6.875C6.94375 9.65625 7 9.6 7 9.53125V8.78125C7 8.7125 6.94375 8.65625 6.875 8.65625ZM3.875 6.65625V7.40625C3.875 7.475 3.93125 7.53125 4 7.53125H10C10.0688 7.53125 10.125 7.475 10.125 7.40625V6.65625C10.125 6.5875 10.0688 6.53125 10 6.53125H4C3.93125 6.53125 3.875 6.5875 3.875 6.65625Z"
    />
  </svg>
);
